import { isBOE } from 'src/const/boe';
/**
 * @file Consts for agent related
 */

/**
 * 代理商平台分配的角色
 */
export const EnumAgentRoleAssigned = {
  OBSERVER: 2,
  OPERATOR: 1,
  ADMIN: 0,
};

export const bcRole = {
  ADMIN: 0,
  OPERATOR: 1,
  ANALYST: 2,
};

export const bcRoleMap = {
  [bcRole.ADMIN]: {
    name_i18n: 'module_bc_role_admin',
  },
  [bcRole.OPERATOR]: {
    name_i18n: 'module_bc_role_operator',
  },
  [bcRole.ANALYST]: {
    name_i18n: 'module_bc_role_analyst',
  },
};

export const accountOwnerType = {
  BC: 1,
  PERSONAL: 2,
};

export const accountOwnerTypeMap = {
  [accountOwnerType.BC]: {
    value: 1,
  },
  [accountOwnerType.PERSONAL]: {
    value: 2,
  },
};

// 常用URL
const { protocol, host } = window.location;
const toBcHostMap = {
  'boe-ads.tiktok.com': 'boe-business.tiktok.com',
  'boei18n-ads.byteoversea.net': 'boei18n-business.byteoversea.net',
};
const BOE_BC_HOST = toBcHostMap[host];
const NORMAL_BC_HOST = 'business.tiktok.com';
const OTHER_BC_HOST = `${host}/bc`;

let CURRENT_BC_HOST = OTHER_BC_HOST;
const isNormal = host === 'ads.tiktok.com';

if (isBOE) CURRENT_BC_HOST = BOE_BC_HOST;
if (isNormal) CURRENT_BC_HOST = NORMAL_BC_HOST;

export const BC_ORIGIN = `${protocol}//${CURRENT_BC_HOST}`;

export const BC_HOME_URL = BC_ORIGIN;

export const BC_AD_ACCOUNT_URL = `${BC_ORIGIN}/manage/account`;
export const bc_info_url = `//${CURRENT_BC_HOST}/manage/info`;
